import { useRef } from "react";
import { isInWework } from "src/common/client-platform";
import useSearchs from "./use-searchs";

export type SuccessCallback = (code: string) => void

function useWeworkClientAutoLogin(wxCorpId: string, state: string) {
  const inWeworkClient = isInWework();

  const { code, weworkclientautologin } = useSearchs()
  const successCallbackRef = useRef<SuccessCallback | null>(null)

  function onSuccess(cb: SuccessCallback) {
    successCallbackRef.current = cb
  }

  function tryWeworkClientAutoLogin() {
    if (!inWeworkClient || !wxCorpId) {
      return
    }

    // check code. if code fetched, and has specified flag
    if (code && weworkclientautologin) {
      successCallbackRef.current?.(code)
      return
    }

    // construct wework login url
    let href = window.location.href
    // append a flag to href
    const flagName = 'weworkclientautologin'
    if (href.includes('?')) {
      href = `${href}&${flagName}=1`
    } else {
      href = `${href}?${flagName}=1`
    }
    const redirectUrl = encodeURIComponent(href)
    const oauth2Url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxCorpId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;
    window.location.href = oauth2Url;
  }

  return {
    onSuccess,
    tryWeworkClientAutoLogin
  }
}


export default useWeworkClientAutoLogin
